export const environment = {
  production: true,
  refreshInterval: 30 * 1000,
  inactivity: 120 * 1000,
  endpoints: {
    webSocket: '/api/ws',
    api: '/api',
  },
  preconnect: ['/api'],
};
